/** 수업시간 설정 등과 동일: 클래스명 `::1,2` 학년 접미 파싱 */
export function parseGradeDisplayName(raw: string): { title: string; grades: number[] } {
  const [base, rest] = raw.split('::');
  if (!rest) return { title: base || raw, grades: [] };
  const nums = rest
    .split(',')
    .map((v) => Number(v))
    .filter((n) => Number.isInteger(n) && n >= 1 && n <= 6);
  return { title: base || raw, grades: nums };
}

/** 클래스 표시 이름(학년 접미 제외) 최대 글자 수 */
export const CLASS_DISPLAY_NAME_MAX_LENGTH = 10;

/** 클래스 표시 이름을 상한까지 자름(앞뒤 공백 trim 후) */
export function clampClassDisplayName(name: string): string {
  return name.trim().slice(0, CLASS_DISPLAY_NAME_MAX_LENGTH);
}

/** 클래스명에 포함된 학년 중 가장 낮은 학년(1~6). 없으면 1. */
export function lowestGradeNumberFromDisplayName(raw: string): 1 | 2 | 3 | 4 | 5 | 6 {
  const { grades } = parseGradeDisplayName(raw);
  if (!grades.length) return 1;
  return Math.min(...grades) as 1 | 2 | 3 | 4 | 5 | 6;
}
